import { LayoutDashboard, Building2, Users, Users2, User, UserSquare2, CalendarRange, Flag, ListOrdered, TrendingUp, Trophy, FileText, Settings, FolderKanban, ClipboardCheck } from "lucide-react";

export const TRACK_NAV = [
  { key: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { key: "organizations", label: "Organizations", icon: Building2 },
  { key: "coaches", label: "Coaches", icon: Users },
  { key: "groups", label: "Athlete Groups", icon: FolderKanban },
  { key: "testing", label: "Testing", icon: ClipboardCheck },
  { key: "teams", label: "Teams", icon: Users2 },
  { key: "male_roster", label: "Male Roster", icon: User },
  { key: "female_roster", label: "Female Roster", icon: UserSquare2 },
  { key: "seasons", label: "Seasons", icon: CalendarRange },
  { key: "meets", label: "Meets", icon: Flag },
  { key: "results", label: "Results", icon: ListOrdered },
  { key: "performance", label: "Athlete Performance", icon: TrendingUp },
  { key: "rankings", label: "Team Rankings", icon: Trophy },
  { key: "reports", label: "Reports", icon: FileText },
  { key: "settings", label: "Settings", icon: Settings },
];

export const TRACK_EMPTY = {
  dashboard: { title: "Command Center", msg: "Your Track OS overview — team metrics, upcoming meets and recent results — will appear here as data is added." },
  teams: { title: "Teams", msg: "No teams yet. Team management arrives in the next phase." },
  male_roster: { title: "Male Roster", msg: "No athletes on the roster yet. Roster management arrives in the next phase." },
  female_roster: { title: "Female Roster", msg: "No athletes on the roster yet. Roster management arrives in the next phase." },
  seasons: { title: "Seasons", msg: "No seasons created yet. Season management arrives in the next phase." },
  meets: { title: "Meets", msg: "No meets scheduled yet. Meet management and result entry arrive in the next phase." },
  results: { title: "Results", msg: "No results yet. Meet result entry arrives in the next phase." },
  performance: { title: "Athlete Performance", msg: "Performance stats, averages and progress charts will appear here once results are entered." },
  rankings: { title: "Team Rankings", msg: "Team rankings will be calculated automatically once results are recorded." },
  reports: { title: "Reports", msg: "Downloadable reports will be available once your program has data." },
  settings: { title: "Settings", msg: "Account and organization settings will appear here." },
  coaches: { title: "Coaches", msg: "Coach directory for your organization will appear here." },
  organizations: { title: "Organizations", msg: "Organization details will appear here." },
};

export const ORG_TYPE_LABELS = { club: "Club", high_school: "High School", college: "College" };
export const COACH_ROLE_LABELS = {
  head_coach: "Head Coach", assistant_coach: "Assistant Coach", sprint_coach: "Sprint Coach",
  hurdles_coach: "Hurdles Coach", distance_coach: "Distance Coach", cross_country_coach: "Cross Country Coach",
  jumps_coach: "Jumps Coach", throws_coach: "Throws Coach", combined_events_coach: "Combined Events Coach",
  data_entry_coach: "Data Entry Coach", read_only: "Read Only",
};
